import i18n from '../i18n';

const getFilterLabels = (): Record<string, string> => ({
    situacao: i18n.t('report.fields.situation'),
    situation: i18n.t('report.fields.situation'),
    client: i18n.t('release.fields.client'),
    from: i18n.t('report.fields.from'),
    arrivalDate: i18n.t('release.fields.arrivalDate'),
    weight: i18n.t('release.fields.weight'),
    dawb: i18n.t('release.fields.dawb'),
    fromDate: i18n.t('report.labels.from'),
    toDate: i18n.t('report.labels.to'),
    invoice: i18n.t('release.fields.invoice'),
    poNumber: i18n.t('release.fields.poNumber'),
    soNumber: i18n.t('user.fields.soNumber'),
    supplier: i18n.t('release.fields.supplier'),
    suppliername: i18n.t('release.fields.supplier'),
    description: i18n.t('release.fields.description'),
    wrNumber: i18n.t('release.fields.wrNumber'),
    pu: i18n.t('release.fields.pu'),
    Pu: i18n.t('release.fields.pu'),
    input: i18n.t('user.fields.inputDate'),
    Input: i18n.t('user.fields.inputDate')
});

export default getFilterLabels;
